/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiResponseDTOListRequiredDocumentDTO,
  ApiResponseDTOListSelfRegistrationSessionDTO,
  ApiResponseDTOSelfRegistrationDashboardDTO,
  ApiResponseDTOSelfRegistrationReportDTO,
  ApiResponseDTOSelfRegistrationSessionDTO,
  ApiResponseDTOUploadedDocumentDTO,
  CompleteManagementRegistrationParams,
  CompleteRegistrationParams,
  DepositRequestDTO,
  DepositUpdateRequestDTO,
  DownloadDepositEvidenceParams,
  DownloadDocumentParams,
  GetPendingReviewsParams,
  GetRegistrationReportsParams,
  InitiateEmailVerificationParams,
  OfficerReviewRequestDTO,
  ResendEmailOtpParams,
  ResendPhoneOtpParams,
  SelfRegistrationRequestDTO,
  SelfRegistrationStepRequestDTO,
  SubmitDirectDepositEvidenceBody,
  UpdateLocationInfoParams,
  UploadDocumentBody,
  UploadDocumentParams
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Process initial deposit for self-registration session. Supports both bank and mobile money payments.
 * @summary Process deposit for self-registration
 */
export const processDeposit = (
    sessionToken: string,
    depositRequestDTO: DepositRequestDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/${sessionToken}/deposit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: depositRequestDTO, signal
    },
      options);
    }
  


export const getProcessDepositMutationOptions = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processDeposit>>, TError,{sessionToken: string;data: DepositRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof processDeposit>>, TError,{sessionToken: string;data: DepositRequestDTO}, TContext> => {

const mutationKey = ['processDeposit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof processDeposit>>, {sessionToken: string;data: DepositRequestDTO}> = (props) => {
          const {sessionToken,data} = props ?? {};

          return  processDeposit(sessionToken,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProcessDepositMutationResult = NonNullable<Awaited<ReturnType<typeof processDeposit>>>
    export type ProcessDepositMutationBody = DepositRequestDTO
    export type ProcessDepositMutationError = ApiResponseDTOSelfRegistrationSessionDTO

    /**
 * @summary Process deposit for self-registration
 */
export const useProcessDeposit = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processDeposit>>, TError,{sessionToken: string;data: DepositRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof processDeposit>>,
        TError,
        {sessionToken: string;data: DepositRequestDTO},
        TContext
      > => {

      const mutationOptions = getProcessDepositMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Update deposit information, mainly for bank deposit evidence upload.
 * @summary Update deposit information
 */
export const updateDepositInfo = (
    sessionToken: string,
    depositUpdateRequestDTO: DepositUpdateRequestDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/${sessionToken}/deposit/update`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: depositUpdateRequestDTO, signal
    },
      options);
    }
  


export const getUpdateDepositInfoMutationOptions = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDepositInfo>>, TError,{sessionToken: string;data: DepositUpdateRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDepositInfo>>, TError,{sessionToken: string;data: DepositUpdateRequestDTO}, TContext> => {

const mutationKey = ['updateDepositInfo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDepositInfo>>, {sessionToken: string;data: DepositUpdateRequestDTO}> = (props) => {
          const {sessionToken,data} = props ?? {};

          return  updateDepositInfo(sessionToken,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDepositInfoMutationResult = NonNullable<Awaited<ReturnType<typeof updateDepositInfo>>>
    export type UpdateDepositInfoMutationBody = DepositUpdateRequestDTO
    export type UpdateDepositInfoMutationError = ApiResponseDTOSelfRegistrationSessionDTO

    /**
 * @summary Update deposit information
 */
export const useUpdateDepositInfo = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDepositInfo>>, TError,{sessionToken: string;data: DepositUpdateRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDepositInfo>>,
        TError,
        {sessionToken: string;data: DepositUpdateRequestDTO},
        TContext
      > => {

      const mutationOptions = getUpdateDepositInfoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Mark deposit as completed after officer review. Used for bank deposits.
 * @summary Complete deposit (Officer action)
 */
export const completeDeposit = (
    sessionToken: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/${sessionToken}/deposit/complete`, method: 'POST', signal
    },
      options);
    }
  


export const getCompleteDepositMutationOptions = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeDeposit>>, TError,{sessionToken: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof completeDeposit>>, TError,{sessionToken: string}, TContext> => {

const mutationKey = ['completeDeposit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeDeposit>>, {sessionToken: string}> = (props) => {
          const {sessionToken} = props ?? {};

          return  completeDeposit(sessionToken,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompleteDepositMutationResult = NonNullable<Awaited<ReturnType<typeof completeDeposit>>>
    
    export type CompleteDepositMutationError = ApiResponseDTOSelfRegistrationSessionDTO

    /**
 * @summary Complete deposit (Officer action)
 */
export const useCompleteDeposit = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeDeposit>>, TError,{sessionToken: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeDeposit>>,
        TError,
        {sessionToken: string},
        TContext
      > => {

      const mutationOptions = getCompleteDepositMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Verify phone number using OTP code. Generates session token for subsequent steps.
 * @summary Verify phone number with OTP
 */
export const verifyPhone = (
    selfRegistrationStepRequestDTO: SelfRegistrationStepRequestDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/verify-phone`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: selfRegistrationStepRequestDTO, signal
    },
      options);
    }
  


export const getVerifyPhoneMutationOptions = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyPhone>>, TError,{data: SelfRegistrationStepRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyPhone>>, TError,{data: SelfRegistrationStepRequestDTO}, TContext> => {

const mutationKey = ['verifyPhone'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyPhone>>, {data: SelfRegistrationStepRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  verifyPhone(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerifyPhoneMutationResult = NonNullable<Awaited<ReturnType<typeof verifyPhone>>>
    export type VerifyPhoneMutationBody = SelfRegistrationStepRequestDTO
    export type VerifyPhoneMutationError = ApiResponseDTOSelfRegistrationSessionDTO

    /**
 * @summary Verify phone number with OTP
 */
export const useVerifyPhone = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyPhone>>, TError,{data: SelfRegistrationStepRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyPhone>>,
        TError,
        {data: SelfRegistrationStepRequestDTO},
        TContext
      > => {

      const mutationOptions = getVerifyPhoneMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Verify email address using OTP code.
 * @summary Verify email with OTP
 */
export const verifyEmail = (
    selfRegistrationStepRequestDTO: SelfRegistrationStepRequestDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/verify-email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: selfRegistrationStepRequestDTO, signal
    },
      options);
    }
  


export const getVerifyEmailMutationOptions = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyEmail>>, TError,{data: SelfRegistrationStepRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyEmail>>, TError,{data: SelfRegistrationStepRequestDTO}, TContext> => {

const mutationKey = ['verifyEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyEmail>>, {data: SelfRegistrationStepRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  verifyEmail(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerifyEmailMutationResult = NonNullable<Awaited<ReturnType<typeof verifyEmail>>>
    export type VerifyEmailMutationBody = SelfRegistrationStepRequestDTO
    export type VerifyEmailMutationError = ApiResponseDTOSelfRegistrationSessionDTO

    /**
 * @summary Verify email with OTP
 */
export const useVerifyEmail = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyEmail>>, TError,{data: SelfRegistrationStepRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyEmail>>,
        TError,
        {data: SelfRegistrationStepRequestDTO},
        TContext
      > => {

      const mutationOptions = getVerifyEmailMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Upload a required document file.
 * @summary Upload a single required document
 */
export const uploadDocument = (
    uploadDocumentBody: UploadDocumentBody,
    params: UploadDocumentParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`file`, uploadDocumentBody.file)

      return customInstance<ApiResponseDTOUploadedDocumentDTO>(
      {url: `/frontend/v1/self-registration/upload-document`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData,
        params, signal
    },
      options);
    }
  


export const getUploadDocumentMutationOptions = <TError = ApiResponseDTOUploadedDocumentDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDocument>>, TError,{data: UploadDocumentBody;params: UploadDocumentParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadDocument>>, TError,{data: UploadDocumentBody;params: UploadDocumentParams}, TContext> => {

const mutationKey = ['uploadDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadDocument>>, {data: UploadDocumentBody;params: UploadDocumentParams}> = (props) => {
          const {data,params} = props ?? {};

          return  uploadDocument(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadDocument>>>
    export type UploadDocumentMutationBody = UploadDocumentBody
    export type UploadDocumentMutationError = ApiResponseDTOUploadedDocumentDTO

    /**
 * @summary Upload a single required document
 */
export const useUploadDocument = <TError = ApiResponseDTOUploadedDocumentDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDocument>>, TError,{data: UploadDocumentBody;params: UploadDocumentParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadDocument>>,
        TError,
        {data: UploadDocumentBody;params: UploadDocumentParams},
        TContext
      > => {

      const mutationOptions = getUploadDocumentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Update personal, employment, and location information.
 * @summary Update personal information
 */
export const updatePersonalInfo = (
    selfRegistrationStepRequestDTO: SelfRegistrationStepRequestDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/update-personal-info`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: selfRegistrationStepRequestDTO, signal
    },
      options);
    }
  


export const getUpdatePersonalInfoMutationOptions = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePersonalInfo>>, TError,{data: SelfRegistrationStepRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePersonalInfo>>, TError,{data: SelfRegistrationStepRequestDTO}, TContext> => {

const mutationKey = ['updatePersonalInfo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePersonalInfo>>, {data: SelfRegistrationStepRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  updatePersonalInfo(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePersonalInfoMutationResult = NonNullable<Awaited<ReturnType<typeof updatePersonalInfo>>>
    export type UpdatePersonalInfoMutationBody = SelfRegistrationStepRequestDTO
    export type UpdatePersonalInfoMutationError = ApiResponseDTOSelfRegistrationSessionDTO

    /**
 * @summary Update personal information
 */
export const useUpdatePersonalInfo = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePersonalInfo>>, TError,{data: SelfRegistrationStepRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePersonalInfo>>,
        TError,
        {data: SelfRegistrationStepRequestDTO},
        TContext
      > => {

      const mutationOptions = getUpdatePersonalInfoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Update location information with JSON data from location selector.
 * @summary Update location information
 */
export const updateLocationInfo = (
    selfRegistrationStepRequestDTO: SelfRegistrationStepRequestDTO,
    params?: UpdateLocationInfoParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/update-location-info`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: selfRegistrationStepRequestDTO,
        params, signal
    },
      options);
    }
  


export const getUpdateLocationInfoMutationOptions = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocationInfo>>, TError,{data: SelfRegistrationStepRequestDTO;params?: UpdateLocationInfoParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLocationInfo>>, TError,{data: SelfRegistrationStepRequestDTO;params?: UpdateLocationInfoParams}, TContext> => {

const mutationKey = ['updateLocationInfo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLocationInfo>>, {data: SelfRegistrationStepRequestDTO;params?: UpdateLocationInfoParams}> = (props) => {
          const {data,params} = props ?? {};

          return  updateLocationInfo(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateLocationInfoMutationResult = NonNullable<Awaited<ReturnType<typeof updateLocationInfo>>>
    export type UpdateLocationInfoMutationBody = SelfRegistrationStepRequestDTO
    export type UpdateLocationInfoMutationError = ApiResponseDTOSelfRegistrationSessionDTO

    /**
 * @summary Update location information
 */
export const useUpdateLocationInfo = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocationInfo>>, TError,{data: SelfRegistrationStepRequestDTO;params?: UpdateLocationInfoParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLocationInfo>>,
        TError,
        {data: SelfRegistrationStepRequestDTO;params?: UpdateLocationInfoParams},
        TContext
      > => {

      const mutationOptions = getUpdateLocationInfoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Upload proof of payment for a direct bank transfer. This moves the session to officer review.
 * @summary Submit direct deposit evidence
 */
export const submitDirectDepositEvidence = (
    submitDirectDepositEvidenceBody: SubmitDirectDepositEvidenceBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`sessionToken`, submitDirectDepositEvidenceBody.sessionToken)
formData.append(`evidence`, submitDirectDepositEvidenceBody.evidence)
formData.append(`file`, submitDirectDepositEvidenceBody.file)

      return customInstance<ApiResponseDTOSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/submit-direct-deposit`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getSubmitDirectDepositEvidenceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitDirectDepositEvidence>>, TError,{data: SubmitDirectDepositEvidenceBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof submitDirectDepositEvidence>>, TError,{data: SubmitDirectDepositEvidenceBody}, TContext> => {

const mutationKey = ['submitDirectDepositEvidence'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitDirectDepositEvidence>>, {data: SubmitDirectDepositEvidenceBody}> = (props) => {
          const {data} = props ?? {};

          return  submitDirectDepositEvidence(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitDirectDepositEvidenceMutationResult = NonNullable<Awaited<ReturnType<typeof submitDirectDepositEvidence>>>
    export type SubmitDirectDepositEvidenceMutationBody = SubmitDirectDepositEvidenceBody
    export type SubmitDirectDepositEvidenceMutationError = unknown

    /**
 * @summary Submit direct deposit evidence
 */
export const useSubmitDirectDepositEvidence = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitDirectDepositEvidence>>, TError,{data: SubmitDirectDepositEvidenceBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitDirectDepositEvidence>>,
        TError,
        {data: SubmitDirectDepositEvidenceBody},
        TContext
      > => {

      const mutationOptions = getSubmitDirectDepositEvidenceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Approve or reject direct deposit evidence for sessions in DEPOSIT step with directDepositPendingReview = true.
 * @summary Review direct deposit evidence
 */
export const reviewDepositEvidence = (
    officerReviewRequestDTO: OfficerReviewRequestDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/review`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: officerReviewRequestDTO, signal
    },
      options);
    }
  


export const getReviewDepositEvidenceMutationOptions = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewDepositEvidence>>, TError,{data: OfficerReviewRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reviewDepositEvidence>>, TError,{data: OfficerReviewRequestDTO}, TContext> => {

const mutationKey = ['reviewDepositEvidence'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviewDepositEvidence>>, {data: OfficerReviewRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  reviewDepositEvidence(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReviewDepositEvidenceMutationResult = NonNullable<Awaited<ReturnType<typeof reviewDepositEvidence>>>
    export type ReviewDepositEvidenceMutationBody = OfficerReviewRequestDTO
    export type ReviewDepositEvidenceMutationError = ApiResponseDTOSelfRegistrationSessionDTO

    /**
 * @summary Review direct deposit evidence
 */
export const useReviewDepositEvidence = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewDepositEvidence>>, TError,{data: OfficerReviewRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reviewDepositEvidence>>,
        TError,
        {data: OfficerReviewRequestDTO},
        TContext
      > => {

      const mutationOptions = getReviewDepositEvidenceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Resend OTP to phone number. Subject to rate limiting.
 * @summary Resend phone OTP
 */
export const resendPhoneOtp = (
    params: ResendPhoneOtpParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/resend-phone-otp`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getResendPhoneOtpMutationOptions = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendPhoneOtp>>, TError,{params: ResendPhoneOtpParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resendPhoneOtp>>, TError,{params: ResendPhoneOtpParams}, TContext> => {

const mutationKey = ['resendPhoneOtp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendPhoneOtp>>, {params: ResendPhoneOtpParams}> = (props) => {
          const {params} = props ?? {};

          return  resendPhoneOtp(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResendPhoneOtpMutationResult = NonNullable<Awaited<ReturnType<typeof resendPhoneOtp>>>
    
    export type ResendPhoneOtpMutationError = ApiResponseDTOSelfRegistrationSessionDTO

    /**
 * @summary Resend phone OTP
 */
export const useResendPhoneOtp = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendPhoneOtp>>, TError,{params: ResendPhoneOtpParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resendPhoneOtp>>,
        TError,
        {params: ResendPhoneOtpParams},
        TContext
      > => {

      const mutationOptions = getResendPhoneOtpMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Resend OTP to email address. Subject to rate limiting.
 * @summary Resend email OTP
 */
export const resendEmailOtp = (
    params: ResendEmailOtpParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/resend-email-otp`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getResendEmailOtpMutationOptions = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendEmailOtp>>, TError,{params: ResendEmailOtpParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resendEmailOtp>>, TError,{params: ResendEmailOtpParams}, TContext> => {

const mutationKey = ['resendEmailOtp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendEmailOtp>>, {params: ResendEmailOtpParams}> = (props) => {
          const {params} = props ?? {};

          return  resendEmailOtp(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResendEmailOtpMutationResult = NonNullable<Awaited<ReturnType<typeof resendEmailOtp>>>
    
    export type ResendEmailOtpMutationError = ApiResponseDTOSelfRegistrationSessionDTO

    /**
 * @summary Resend email OTP
 */
export const useResendEmailOtp = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendEmailOtp>>, TError,{params: ResendEmailOtpParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resendEmailOtp>>,
        TError,
        {params: ResendEmailOtpParams},
        TContext
      > => {

      const mutationOptions = getResendEmailOtpMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Reject a self-registration session with a reason.
 * @summary Reject a self-registration session
 */
export const rejectSession = (
    officerReviewRequestDTO: OfficerReviewRequestDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/reject-session`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: officerReviewRequestDTO, signal
    },
      options);
    }
  


export const getRejectSessionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectSession>>, TError,{data: OfficerReviewRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectSession>>, TError,{data: OfficerReviewRequestDTO}, TContext> => {

const mutationKey = ['rejectSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectSession>>, {data: OfficerReviewRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  rejectSession(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RejectSessionMutationResult = NonNullable<Awaited<ReturnType<typeof rejectSession>>>
    export type RejectSessionMutationBody = OfficerReviewRequestDTO
    export type RejectSessionMutationError = unknown

    /**
 * @summary Reject a self-registration session
 */
export const useRejectSession = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectSession>>, TError,{data: OfficerReviewRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectSession>>,
        TError,
        {data: OfficerReviewRequestDTO},
        TContext
      > => {

      const mutationOptions = getRejectSessionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Complete a self-registration request from the management page using relaxed out-of-flow rules.
 * @summary Complete registration from management
 */
export const completeManagementRegistration = (
    params: CompleteManagementRegistrationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/management/complete`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getCompleteManagementRegistrationMutationOptions = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeManagementRegistration>>, TError,{params: CompleteManagementRegistrationParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof completeManagementRegistration>>, TError,{params: CompleteManagementRegistrationParams}, TContext> => {

const mutationKey = ['completeManagementRegistration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeManagementRegistration>>, {params: CompleteManagementRegistrationParams}> = (props) => {
          const {params} = props ?? {};

          return  completeManagementRegistration(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompleteManagementRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof completeManagementRegistration>>>
    
    export type CompleteManagementRegistrationMutationError = ApiResponseDTOSelfRegistrationSessionDTO

    /**
 * @summary Complete registration from management
 */
export const useCompleteManagementRegistration = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeManagementRegistration>>, TError,{params: CompleteManagementRegistrationParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeManagementRegistration>>,
        TError,
        {params: CompleteManagementRegistrationParams},
        TContext
      > => {

      const mutationOptions = getCompleteManagementRegistrationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Start the self-registration process with phone number and basic info. Sends OTP to phone.
 * @summary Initiate self-registration process
 */
export const initiateRegistration = (
    selfRegistrationRequestDTO: SelfRegistrationRequestDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/initiate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: selfRegistrationRequestDTO, signal
    },
      options);
    }
  


export const getInitiateRegistrationMutationOptions = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiateRegistration>>, TError,{data: SelfRegistrationRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof initiateRegistration>>, TError,{data: SelfRegistrationRequestDTO}, TContext> => {

const mutationKey = ['initiateRegistration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initiateRegistration>>, {data: SelfRegistrationRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  initiateRegistration(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InitiateRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof initiateRegistration>>>
    export type InitiateRegistrationMutationBody = SelfRegistrationRequestDTO
    export type InitiateRegistrationMutationError = ApiResponseDTOSelfRegistrationSessionDTO

    /**
 * @summary Initiate self-registration process
 */
export const useInitiateRegistration = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiateRegistration>>, TError,{data: SelfRegistrationRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof initiateRegistration>>,
        TError,
        {data: SelfRegistrationRequestDTO},
        TContext
      > => {

      const mutationOptions = getInitiateRegistrationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Send OTP to email address for verification.
 * @summary Initiate email verification
 */
export const initiateEmailVerification = (
    params: InitiateEmailVerificationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/initiate-email-verification`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getInitiateEmailVerificationMutationOptions = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiateEmailVerification>>, TError,{params: InitiateEmailVerificationParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof initiateEmailVerification>>, TError,{params: InitiateEmailVerificationParams}, TContext> => {

const mutationKey = ['initiateEmailVerification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initiateEmailVerification>>, {params: InitiateEmailVerificationParams}> = (props) => {
          const {params} = props ?? {};

          return  initiateEmailVerification(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InitiateEmailVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof initiateEmailVerification>>>
    
    export type InitiateEmailVerificationMutationError = ApiResponseDTOSelfRegistrationSessionDTO

    /**
 * @summary Initiate email verification
 */
export const useInitiateEmailVerification = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiateEmailVerification>>, TError,{params: InitiateEmailVerificationParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof initiateEmailVerification>>,
        TError,
        {params: InitiateEmailVerificationParams},
        TContext
      > => {

      const mutationOptions = getInitiateEmailVerificationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Complete the self-registration process.
 * @summary Complete registration
 */
export const completeRegistration = (
    params: CompleteRegistrationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/complete`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getCompleteRegistrationMutationOptions = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeRegistration>>, TError,{params: CompleteRegistrationParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof completeRegistration>>, TError,{params: CompleteRegistrationParams}, TContext> => {

const mutationKey = ['completeRegistration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeRegistration>>, {params: CompleteRegistrationParams}> = (props) => {
          const {params} = props ?? {};

          return  completeRegistration(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompleteRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof completeRegistration>>>
    
    export type CompleteRegistrationMutationError = ApiResponseDTOSelfRegistrationSessionDTO

    /**
 * @summary Complete registration
 */
export const useCompleteRegistration = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeRegistration>>, TError,{params: CompleteRegistrationParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeRegistration>>,
        TError,
        {params: CompleteRegistrationParams},
        TContext
      > => {

      const mutationOptions = getCompleteRegistrationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Process officer review for both general approvals (PENDING_OFFICER_REVIEW status) and direct deposit evidence reviews. Supports both APPROVE and REJECT actions based on the request action field.
 * @summary Process officer review (approve/reject)
 */
export const approveSession = (
    officerReviewRequestDTO: OfficerReviewRequestDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/approve-session`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: officerReviewRequestDTO, signal
    },
      options);
    }
  


export const getApproveSessionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveSession>>, TError,{data: OfficerReviewRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof approveSession>>, TError,{data: OfficerReviewRequestDTO}, TContext> => {

const mutationKey = ['approveSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveSession>>, {data: OfficerReviewRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  approveSession(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApproveSessionMutationResult = NonNullable<Awaited<ReturnType<typeof approveSession>>>
    export type ApproveSessionMutationBody = OfficerReviewRequestDTO
    export type ApproveSessionMutationError = unknown

    /**
 * @summary Process officer review (approve/reject)
 */
export const useApproveSession = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveSession>>, TError,{data: OfficerReviewRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveSession>>,
        TError,
        {data: OfficerReviewRequestDTO},
        TContext
      > => {

      const mutationOptions = getApproveSessionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Accept terms and conditions to proceed with registration.
 * @summary Accept terms and conditions
 */
export const acceptTerms = (
    selfRegistrationStepRequestDTO: SelfRegistrationStepRequestDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/accept-terms`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: selfRegistrationStepRequestDTO, signal
    },
      options);
    }
  


export const getAcceptTermsMutationOptions = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptTerms>>, TError,{data: SelfRegistrationStepRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptTerms>>, TError,{data: SelfRegistrationStepRequestDTO}, TContext> => {

const mutationKey = ['acceptTerms'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptTerms>>, {data: SelfRegistrationStepRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  acceptTerms(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcceptTermsMutationResult = NonNullable<Awaited<ReturnType<typeof acceptTerms>>>
    export type AcceptTermsMutationBody = SelfRegistrationStepRequestDTO
    export type AcceptTermsMutationError = ApiResponseDTOSelfRegistrationSessionDTO

    /**
 * @summary Accept terms and conditions
 */
export const useAcceptTerms = <TError = ApiResponseDTOSelfRegistrationSessionDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptTerms>>, TError,{data: SelfRegistrationStepRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptTerms>>,
        TError,
        {data: SelfRegistrationStepRequestDTO},
        TContext
      > => {

      const mutationOptions = getAcceptTermsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get current registration session details.
 * @summary Get registration session
 */
export const getSession = (
    sessionToken: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/session/${sessionToken}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetSessionInfiniteQueryKey = (sessionToken?: string,) => {
    return [
    'infinite', `/frontend/v1/self-registration/session/${sessionToken}`
    ] as const;
    }

export const getGetSessionQueryKey = (sessionToken?: string,) => {
    return [
    `/frontend/v1/self-registration/session/${sessionToken}`
    ] as const;
    }

    
export const getGetSessionInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getSession>>>, TError = ApiResponseDTOSelfRegistrationSessionDTO>(sessionToken: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSessionInfiniteQueryKey(sessionToken);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSession>>> = ({ signal }) => getSession(sessionToken, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionToken), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSessionInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getSession>>>
export type GetSessionInfiniteQueryError = ApiResponseDTOSelfRegistrationSessionDTO


export function useGetSessionInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getSession>>>, TError = ApiResponseDTOSelfRegistrationSessionDTO>(
 sessionToken: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSession>>,
          TError,
          Awaited<ReturnType<typeof getSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSessionInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getSession>>>, TError = ApiResponseDTOSelfRegistrationSessionDTO>(
 sessionToken: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSession>>,
          TError,
          Awaited<ReturnType<typeof getSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSessionInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getSession>>>, TError = ApiResponseDTOSelfRegistrationSessionDTO>(
 sessionToken: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get registration session
 */

export function useGetSessionInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getSession>>>, TError = ApiResponseDTOSelfRegistrationSessionDTO>(
 sessionToken: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSessionInfiniteQueryOptions(sessionToken,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetSessionQueryOptions = <TData = Awaited<ReturnType<typeof getSession>>, TError = ApiResponseDTOSelfRegistrationSessionDTO>(sessionToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSessionQueryKey(sessionToken);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSession>>> = ({ signal }) => getSession(sessionToken, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionToken), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getSession>>>
export type GetSessionQueryError = ApiResponseDTOSelfRegistrationSessionDTO


export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = ApiResponseDTOSelfRegistrationSessionDTO>(
 sessionToken: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSession>>,
          TError,
          Awaited<ReturnType<typeof getSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = ApiResponseDTOSelfRegistrationSessionDTO>(
 sessionToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSession>>,
          TError,
          Awaited<ReturnType<typeof getSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = ApiResponseDTOSelfRegistrationSessionDTO>(
 sessionToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get registration session
 */

export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = ApiResponseDTOSelfRegistrationSessionDTO>(
 sessionToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSessionQueryOptions(sessionToken,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get list of required documents for registration.
 * @summary Get required documents
 */
export const getRequiredDocuments = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOListRequiredDocumentDTO>(
      {url: `/frontend/v1/self-registration/required-documents`, method: 'GET', signal
    },
      options);
    }
  



export const getGetRequiredDocumentsInfiniteQueryKey = () => {
    return [
    'infinite', `/frontend/v1/self-registration/required-documents`
    ] as const;
    }

export const getGetRequiredDocumentsQueryKey = () => {
    return [
    `/frontend/v1/self-registration/required-documents`
    ] as const;
    }

    
export const getGetRequiredDocumentsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getRequiredDocuments>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRequiredDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequiredDocumentsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequiredDocuments>>> = ({ signal }) => getRequiredDocuments(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRequiredDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRequiredDocumentsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getRequiredDocuments>>>
export type GetRequiredDocumentsInfiniteQueryError = unknown


export function useGetRequiredDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getRequiredDocuments>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRequiredDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequiredDocuments>>,
          TError,
          Awaited<ReturnType<typeof getRequiredDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRequiredDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getRequiredDocuments>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRequiredDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequiredDocuments>>,
          TError,
          Awaited<ReturnType<typeof getRequiredDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRequiredDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getRequiredDocuments>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRequiredDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get required documents
 */

export function useGetRequiredDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getRequiredDocuments>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRequiredDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRequiredDocumentsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetRequiredDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getRequiredDocuments>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequiredDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequiredDocumentsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequiredDocuments>>> = ({ signal }) => getRequiredDocuments(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequiredDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRequiredDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getRequiredDocuments>>>
export type GetRequiredDocumentsQueryError = unknown


export function useGetRequiredDocuments<TData = Awaited<ReturnType<typeof getRequiredDocuments>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequiredDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequiredDocuments>>,
          TError,
          Awaited<ReturnType<typeof getRequiredDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRequiredDocuments<TData = Awaited<ReturnType<typeof getRequiredDocuments>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequiredDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequiredDocuments>>,
          TError,
          Awaited<ReturnType<typeof getRequiredDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRequiredDocuments<TData = Awaited<ReturnType<typeof getRequiredDocuments>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequiredDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get required documents
 */

export function useGetRequiredDocuments<TData = Awaited<ReturnType<typeof getRequiredDocuments>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequiredDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRequiredDocumentsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieve all self-registration sessions that are pending officer review. Supports optional search by applicant name, NIDA ID, or email.
 * @summary Get pending self-registration sessions for officer review
 */
export const getPendingReviews = (
    params?: GetPendingReviewsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOListSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/pending-reviews`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPendingReviewsInfiniteQueryKey = (params?: GetPendingReviewsParams,) => {
    return [
    'infinite', `/frontend/v1/self-registration/pending-reviews`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetPendingReviewsQueryKey = (params?: GetPendingReviewsParams,) => {
    return [
    `/frontend/v1/self-registration/pending-reviews`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPendingReviewsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPendingReviews>>>, TError = unknown>(params?: GetPendingReviewsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingReviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingReviewsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingReviews>>> = ({ signal }) => getPendingReviews(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingReviews>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPendingReviewsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingReviews>>>
export type GetPendingReviewsInfiniteQueryError = unknown


export function useGetPendingReviewsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingReviews>>>, TError = unknown>(
 params: undefined |  GetPendingReviewsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingReviews>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingReviews>>,
          TError,
          Awaited<ReturnType<typeof getPendingReviews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingReviewsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingReviews>>>, TError = unknown>(
 params?: GetPendingReviewsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingReviews>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingReviews>>,
          TError,
          Awaited<ReturnType<typeof getPendingReviews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingReviewsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingReviews>>>, TError = unknown>(
 params?: GetPendingReviewsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingReviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get pending self-registration sessions for officer review
 */

export function useGetPendingReviewsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingReviews>>>, TError = unknown>(
 params?: GetPendingReviewsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingReviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPendingReviewsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPendingReviewsQueryOptions = <TData = Awaited<ReturnType<typeof getPendingReviews>>, TError = unknown>(params?: GetPendingReviewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingReviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingReviewsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingReviews>>> = ({ signal }) => getPendingReviews(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingReviews>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPendingReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingReviews>>>
export type GetPendingReviewsQueryError = unknown


export function useGetPendingReviews<TData = Awaited<ReturnType<typeof getPendingReviews>>, TError = unknown>(
 params: undefined |  GetPendingReviewsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingReviews>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingReviews>>,
          TError,
          Awaited<ReturnType<typeof getPendingReviews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingReviews<TData = Awaited<ReturnType<typeof getPendingReviews>>, TError = unknown>(
 params?: GetPendingReviewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingReviews>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingReviews>>,
          TError,
          Awaited<ReturnType<typeof getPendingReviews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingReviews<TData = Awaited<ReturnType<typeof getPendingReviews>>, TError = unknown>(
 params?: GetPendingReviewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingReviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get pending self-registration sessions for officer review
 */

export function useGetPendingReviews<TData = Awaited<ReturnType<typeof getPendingReviews>>, TError = unknown>(
 params?: GetPendingReviewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingReviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPendingReviewsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieve self-registration sessions in DEPOSIT step with directDepositPendingReview = true.
 * @summary Get pending direct deposit evidence reviews
 */
export const getPendingDirectDepositReviews = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOListSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/pending-reviews/direct-deposit`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPendingDirectDepositReviewsInfiniteQueryKey = () => {
    return [
    'infinite', `/frontend/v1/self-registration/pending-reviews/direct-deposit`
    ] as const;
    }

export const getGetPendingDirectDepositReviewsQueryKey = () => {
    return [
    `/frontend/v1/self-registration/pending-reviews/direct-deposit`
    ] as const;
    }

    
export const getGetPendingDirectDepositReviewsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPendingDirectDepositReviews>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingDirectDepositReviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingDirectDepositReviewsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingDirectDepositReviews>>> = ({ signal }) => getPendingDirectDepositReviews(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingDirectDepositReviews>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPendingDirectDepositReviewsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingDirectDepositReviews>>>
export type GetPendingDirectDepositReviewsInfiniteQueryError = unknown


export function useGetPendingDirectDepositReviewsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingDirectDepositReviews>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingDirectDepositReviews>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingDirectDepositReviews>>,
          TError,
          Awaited<ReturnType<typeof getPendingDirectDepositReviews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingDirectDepositReviewsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingDirectDepositReviews>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingDirectDepositReviews>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingDirectDepositReviews>>,
          TError,
          Awaited<ReturnType<typeof getPendingDirectDepositReviews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingDirectDepositReviewsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingDirectDepositReviews>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingDirectDepositReviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get pending direct deposit evidence reviews
 */

export function useGetPendingDirectDepositReviewsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingDirectDepositReviews>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingDirectDepositReviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPendingDirectDepositReviewsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPendingDirectDepositReviewsQueryOptions = <TData = Awaited<ReturnType<typeof getPendingDirectDepositReviews>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDirectDepositReviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingDirectDepositReviewsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingDirectDepositReviews>>> = ({ signal }) => getPendingDirectDepositReviews(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingDirectDepositReviews>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPendingDirectDepositReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingDirectDepositReviews>>>
export type GetPendingDirectDepositReviewsQueryError = unknown


export function useGetPendingDirectDepositReviews<TData = Awaited<ReturnType<typeof getPendingDirectDepositReviews>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDirectDepositReviews>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingDirectDepositReviews>>,
          TError,
          Awaited<ReturnType<typeof getPendingDirectDepositReviews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingDirectDepositReviews<TData = Awaited<ReturnType<typeof getPendingDirectDepositReviews>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDirectDepositReviews>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingDirectDepositReviews>>,
          TError,
          Awaited<ReturnType<typeof getPendingDirectDepositReviews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingDirectDepositReviews<TData = Awaited<ReturnType<typeof getPendingDirectDepositReviews>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDirectDepositReviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get pending direct deposit evidence reviews
 */

export function useGetPendingDirectDepositReviews<TData = Awaited<ReturnType<typeof getPendingDirectDepositReviews>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDirectDepositReviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPendingDirectDepositReviewsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get list of registrations pending officer approval.
 * @summary Get pending approvals
 */
export const getPendingApprovals = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOListSelfRegistrationSessionDTO>(
      {url: `/frontend/v1/self-registration/pending-approvals`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPendingApprovalsInfiniteQueryKey = () => {
    return [
    'infinite', `/frontend/v1/self-registration/pending-approvals`
    ] as const;
    }

export const getGetPendingApprovalsQueryKey = () => {
    return [
    `/frontend/v1/self-registration/pending-approvals`
    ] as const;
    }

    
export const getGetPendingApprovalsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPendingApprovals>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingApprovals>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingApprovalsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingApprovals>>> = ({ signal }) => getPendingApprovals(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingApprovals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPendingApprovalsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingApprovals>>>
export type GetPendingApprovalsInfiniteQueryError = unknown


export function useGetPendingApprovalsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingApprovals>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingApprovals>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingApprovals>>,
          TError,
          Awaited<ReturnType<typeof getPendingApprovals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingApprovalsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingApprovals>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingApprovals>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingApprovals>>,
          TError,
          Awaited<ReturnType<typeof getPendingApprovals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingApprovalsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingApprovals>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingApprovals>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get pending approvals
 */

export function useGetPendingApprovalsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingApprovals>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingApprovals>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPendingApprovalsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPendingApprovalsQueryOptions = <TData = Awaited<ReturnType<typeof getPendingApprovals>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingApprovals>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingApprovalsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingApprovals>>> = ({ signal }) => getPendingApprovals(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingApprovals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPendingApprovalsQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingApprovals>>>
export type GetPendingApprovalsQueryError = unknown


export function useGetPendingApprovals<TData = Awaited<ReturnType<typeof getPendingApprovals>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingApprovals>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingApprovals>>,
          TError,
          Awaited<ReturnType<typeof getPendingApprovals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingApprovals<TData = Awaited<ReturnType<typeof getPendingApprovals>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingApprovals>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingApprovals>>,
          TError,
          Awaited<ReturnType<typeof getPendingApprovals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingApprovals<TData = Awaited<ReturnType<typeof getPendingApprovals>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingApprovals>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get pending approvals
 */

export function useGetPendingApprovals<TData = Awaited<ReturnType<typeof getPendingApprovals>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingApprovals>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPendingApprovalsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Download or view an uploaded document by session token and document ID.
 * @summary Download/view uploaded document
 */
export const downloadDocument = (
    sessionToken: string,
    documentId: number,
    params?: DownloadDocumentParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Blob>(
      {url: `/frontend/v1/self-registration/document/${sessionToken}/${documentId}`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }
  



export const getDownloadDocumentInfiniteQueryKey = (sessionToken?: string,
    documentId?: number,
    params?: DownloadDocumentParams,) => {
    return [
    'infinite', `/frontend/v1/self-registration/document/${sessionToken}/${documentId}`, ...(params ? [params]: [])
    ] as const;
    }

export const getDownloadDocumentQueryKey = (sessionToken?: string,
    documentId?: number,
    params?: DownloadDocumentParams,) => {
    return [
    `/frontend/v1/self-registration/document/${sessionToken}/${documentId}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getDownloadDocumentInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof downloadDocument>>>, TError = Blob>(sessionToken: string,
    documentId: number,
    params?: DownloadDocumentParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadDocumentInfiniteQueryKey(sessionToken,documentId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadDocument>>> = ({ signal }) => downloadDocument(sessionToken,documentId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionToken && documentId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DownloadDocumentInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof downloadDocument>>>
export type DownloadDocumentInfiniteQueryError = Blob


export function useDownloadDocumentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadDocument>>>, TError = Blob>(
 sessionToken: string,
    documentId: number,
    params: undefined |  DownloadDocumentParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDocument>>,
          TError,
          Awaited<ReturnType<typeof downloadDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDownloadDocumentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadDocument>>>, TError = Blob>(
 sessionToken: string,
    documentId: number,
    params?: DownloadDocumentParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDocument>>,
          TError,
          Awaited<ReturnType<typeof downloadDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDownloadDocumentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadDocument>>>, TError = Blob>(
 sessionToken: string,
    documentId: number,
    params?: DownloadDocumentParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Download/view uploaded document
 */

export function useDownloadDocumentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadDocument>>>, TError = Blob>(
 sessionToken: string,
    documentId: number,
    params?: DownloadDocumentParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDownloadDocumentInfiniteQueryOptions(sessionToken,documentId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getDownloadDocumentQueryOptions = <TData = Awaited<ReturnType<typeof downloadDocument>>, TError = Blob>(sessionToken: string,
    documentId: number,
    params?: DownloadDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadDocumentQueryKey(sessionToken,documentId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadDocument>>> = ({ signal }) => downloadDocument(sessionToken,documentId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionToken && documentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DownloadDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof downloadDocument>>>
export type DownloadDocumentQueryError = Blob


export function useDownloadDocument<TData = Awaited<ReturnType<typeof downloadDocument>>, TError = Blob>(
 sessionToken: string,
    documentId: number,
    params: undefined |  DownloadDocumentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDocument>>,
          TError,
          Awaited<ReturnType<typeof downloadDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDownloadDocument<TData = Awaited<ReturnType<typeof downloadDocument>>, TError = Blob>(
 sessionToken: string,
    documentId: number,
    params?: DownloadDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDocument>>,
          TError,
          Awaited<ReturnType<typeof downloadDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDownloadDocument<TData = Awaited<ReturnType<typeof downloadDocument>>, TError = Blob>(
 sessionToken: string,
    documentId: number,
    params?: DownloadDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Download/view uploaded document
 */

export function useDownloadDocument<TData = Awaited<ReturnType<typeof downloadDocument>>, TError = Blob>(
 sessionToken: string,
    documentId: number,
    params?: DownloadDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDownloadDocumentQueryOptions(sessionToken,documentId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Download or view direct deposit evidence file by session token.
 * @summary Download/view direct deposit evidence
 */
export const downloadDepositEvidence = (
    sessionToken: string,
    params?: DownloadDepositEvidenceParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Blob>(
      {url: `/frontend/v1/self-registration/deposit-evidence/${sessionToken}`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }
  



export const getDownloadDepositEvidenceInfiniteQueryKey = (sessionToken?: string,
    params?: DownloadDepositEvidenceParams,) => {
    return [
    'infinite', `/frontend/v1/self-registration/deposit-evidence/${sessionToken}`, ...(params ? [params]: [])
    ] as const;
    }

export const getDownloadDepositEvidenceQueryKey = (sessionToken?: string,
    params?: DownloadDepositEvidenceParams,) => {
    return [
    `/frontend/v1/self-registration/deposit-evidence/${sessionToken}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getDownloadDepositEvidenceInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof downloadDepositEvidence>>>, TError = Blob>(sessionToken: string,
    params?: DownloadDepositEvidenceParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadDepositEvidence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadDepositEvidenceInfiniteQueryKey(sessionToken,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadDepositEvidence>>> = ({ signal }) => downloadDepositEvidence(sessionToken,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionToken), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadDepositEvidence>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DownloadDepositEvidenceInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof downloadDepositEvidence>>>
export type DownloadDepositEvidenceInfiniteQueryError = Blob


export function useDownloadDepositEvidenceInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadDepositEvidence>>>, TError = Blob>(
 sessionToken: string,
    params: undefined |  DownloadDepositEvidenceParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadDepositEvidence>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDepositEvidence>>,
          TError,
          Awaited<ReturnType<typeof downloadDepositEvidence>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDownloadDepositEvidenceInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadDepositEvidence>>>, TError = Blob>(
 sessionToken: string,
    params?: DownloadDepositEvidenceParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadDepositEvidence>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDepositEvidence>>,
          TError,
          Awaited<ReturnType<typeof downloadDepositEvidence>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDownloadDepositEvidenceInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadDepositEvidence>>>, TError = Blob>(
 sessionToken: string,
    params?: DownloadDepositEvidenceParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadDepositEvidence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Download/view direct deposit evidence
 */

export function useDownloadDepositEvidenceInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadDepositEvidence>>>, TError = Blob>(
 sessionToken: string,
    params?: DownloadDepositEvidenceParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadDepositEvidence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDownloadDepositEvidenceInfiniteQueryOptions(sessionToken,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getDownloadDepositEvidenceQueryOptions = <TData = Awaited<ReturnType<typeof downloadDepositEvidence>>, TError = Blob>(sessionToken: string,
    params?: DownloadDepositEvidenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDepositEvidence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadDepositEvidenceQueryKey(sessionToken,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadDepositEvidence>>> = ({ signal }) => downloadDepositEvidence(sessionToken,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionToken), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadDepositEvidence>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DownloadDepositEvidenceQueryResult = NonNullable<Awaited<ReturnType<typeof downloadDepositEvidence>>>
export type DownloadDepositEvidenceQueryError = Blob


export function useDownloadDepositEvidence<TData = Awaited<ReturnType<typeof downloadDepositEvidence>>, TError = Blob>(
 sessionToken: string,
    params: undefined |  DownloadDepositEvidenceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDepositEvidence>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDepositEvidence>>,
          TError,
          Awaited<ReturnType<typeof downloadDepositEvidence>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDownloadDepositEvidence<TData = Awaited<ReturnType<typeof downloadDepositEvidence>>, TError = Blob>(
 sessionToken: string,
    params?: DownloadDepositEvidenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDepositEvidence>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDepositEvidence>>,
          TError,
          Awaited<ReturnType<typeof downloadDepositEvidence>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDownloadDepositEvidence<TData = Awaited<ReturnType<typeof downloadDepositEvidence>>, TError = Blob>(
 sessionToken: string,
    params?: DownloadDepositEvidenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDepositEvidence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Download/view direct deposit evidence
 */

export function useDownloadDepositEvidence<TData = Awaited<ReturnType<typeof downloadDepositEvidence>>, TError = Blob>(
 sessionToken: string,
    params?: DownloadDepositEvidenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDepositEvidence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDownloadDepositEvidenceQueryOptions(sessionToken,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get detailed registration reports with filtering options
 * @summary Get registration reports
 */
export const getRegistrationReports = (
    params?: GetRegistrationReportsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOSelfRegistrationReportDTO>(
      {url: `/frontend/v1/self-registration/analytics/reports`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetRegistrationReportsInfiniteQueryKey = (params?: GetRegistrationReportsParams,) => {
    return [
    'infinite', `/frontend/v1/self-registration/analytics/reports`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetRegistrationReportsQueryKey = (params?: GetRegistrationReportsParams,) => {
    return [
    `/frontend/v1/self-registration/analytics/reports`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetRegistrationReportsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getRegistrationReports>>>, TError = unknown>(params?: GetRegistrationReportsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRegistrationReports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegistrationReportsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegistrationReports>>> = ({ signal }) => getRegistrationReports(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRegistrationReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRegistrationReportsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getRegistrationReports>>>
export type GetRegistrationReportsInfiniteQueryError = unknown


export function useGetRegistrationReportsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getRegistrationReports>>>, TError = unknown>(
 params: undefined |  GetRegistrationReportsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRegistrationReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegistrationReports>>,
          TError,
          Awaited<ReturnType<typeof getRegistrationReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRegistrationReportsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getRegistrationReports>>>, TError = unknown>(
 params?: GetRegistrationReportsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRegistrationReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegistrationReports>>,
          TError,
          Awaited<ReturnType<typeof getRegistrationReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRegistrationReportsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getRegistrationReports>>>, TError = unknown>(
 params?: GetRegistrationReportsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRegistrationReports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get registration reports
 */

export function useGetRegistrationReportsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getRegistrationReports>>>, TError = unknown>(
 params?: GetRegistrationReportsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRegistrationReports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRegistrationReportsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetRegistrationReportsQueryOptions = <TData = Awaited<ReturnType<typeof getRegistrationReports>>, TError = unknown>(params?: GetRegistrationReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegistrationReports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegistrationReportsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegistrationReports>>> = ({ signal }) => getRegistrationReports(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegistrationReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRegistrationReportsQueryResult = NonNullable<Awaited<ReturnType<typeof getRegistrationReports>>>
export type GetRegistrationReportsQueryError = unknown


export function useGetRegistrationReports<TData = Awaited<ReturnType<typeof getRegistrationReports>>, TError = unknown>(
 params: undefined |  GetRegistrationReportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegistrationReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegistrationReports>>,
          TError,
          Awaited<ReturnType<typeof getRegistrationReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRegistrationReports<TData = Awaited<ReturnType<typeof getRegistrationReports>>, TError = unknown>(
 params?: GetRegistrationReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegistrationReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegistrationReports>>,
          TError,
          Awaited<ReturnType<typeof getRegistrationReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRegistrationReports<TData = Awaited<ReturnType<typeof getRegistrationReports>>, TError = unknown>(
 params?: GetRegistrationReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegistrationReports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get registration reports
 */

export function useGetRegistrationReports<TData = Awaited<ReturnType<typeof getRegistrationReports>>, TError = unknown>(
 params?: GetRegistrationReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegistrationReports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRegistrationReportsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get comprehensive dashboard statistics for self-registration
 * @summary Get dashboard statistics
 */
export const getDashboardStatistics = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOSelfRegistrationDashboardDTO>(
      {url: `/frontend/v1/self-registration/analytics/dashboard`, method: 'GET', signal
    },
      options);
    }
  



export const getGetDashboardStatisticsInfiniteQueryKey = () => {
    return [
    'infinite', `/frontend/v1/self-registration/analytics/dashboard`
    ] as const;
    }

export const getGetDashboardStatisticsQueryKey = () => {
    return [
    `/frontend/v1/self-registration/analytics/dashboard`
    ] as const;
    }

    
export const getGetDashboardStatisticsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getDashboardStatistics>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDashboardStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardStatisticsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardStatistics>>> = ({ signal }) => getDashboardStatistics(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDashboardStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDashboardStatisticsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardStatistics>>>
export type GetDashboardStatisticsInfiniteQueryError = unknown


export function useGetDashboardStatisticsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDashboardStatistics>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDashboardStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardStatistics>>,
          TError,
          Awaited<ReturnType<typeof getDashboardStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDashboardStatisticsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDashboardStatistics>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDashboardStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardStatistics>>,
          TError,
          Awaited<ReturnType<typeof getDashboardStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDashboardStatisticsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDashboardStatistics>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDashboardStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get dashboard statistics
 */

export function useGetDashboardStatisticsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDashboardStatistics>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDashboardStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDashboardStatisticsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetDashboardStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardStatistics>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardStatisticsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardStatistics>>> = ({ signal }) => getDashboardStatistics(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDashboardStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardStatistics>>>
export type GetDashboardStatisticsQueryError = unknown


export function useGetDashboardStatistics<TData = Awaited<ReturnType<typeof getDashboardStatistics>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardStatistics>>,
          TError,
          Awaited<ReturnType<typeof getDashboardStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDashboardStatistics<TData = Awaited<ReturnType<typeof getDashboardStatistics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardStatistics>>,
          TError,
          Awaited<ReturnType<typeof getDashboardStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDashboardStatistics<TData = Awaited<ReturnType<typeof getDashboardStatistics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get dashboard statistics
 */

export function useGetDashboardStatistics<TData = Awaited<ReturnType<typeof getDashboardStatistics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDashboardStatisticsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




